import axios from "axios";
import Constants from "../../../components.constants.js";


export default {

  async getChatUsersFromServer(context, payload = {}) {
    try {
      let resp = await axios.get(Constants.messageUsersUrl, payload);
      if (Constants.acceptedStatusCodes.includes(resp.status)) {
        resp.data.statusCode = resp.status
        return resp.data;
      }else {
        throw `Response from server-->${resp.status}, data--->${resp.data}, statusText-->${resp.statusText}`;
      }
    } catch (error) {
      console.error(
        `[getChatUsersFromServer][Store][Error occured while getChatUsersFromServer report list--->${error}]`
      );
      if (error.response) {
        if (error.response.status == 401){
          return context.dispatch("users/logOutFromServer", {},{root:true})
        }
        else {
          error.response.data.statusCode = error.response.status
          return error.response.data
        }
      }
      return {}
    }
  },
   
  async getMessagesUneadCount(context, payload = {}) {
    try {
      let resp = await axios.get(Constants.messagesUrl/'unread-count', payload);
      if (Constants.acceptedStatusCodes.includes(resp.status)) {
        resp.data.statusCode = resp.status
        return resp.data;
      }else {
        throw `Response from server-->${resp.status}, data--->${resp.data}, statusText-->${resp.statusText}`;
      }
    } catch (error) {
      console.error(
        `[getMessagesUneadCount][Store][Error occured while getMessagesUneadCount report list--->${error}]`
      );
      if (error.response) {
        if (error.response.status == 401){
          return context.dispatch("users/logOutFromServer", {},{root:true})
        }
        else {
          error.response.data.statusCode = error.response.status
          return error.response.data
        }
      }
      return {}
    }
  },

  async getChatsFromServer(context, payload = {}) {
    try {
      let resp = await axios.get(Constants.messagesUrl, payload);
      if (Constants.acceptedStatusCodes.includes(resp.status)) {
        resp.data.statusCode = resp.status
        return resp.data;
      }else {
        throw `Response from server-->${resp.status}, data--->${resp.data}, statusText-->${resp.statusText}`;
      }
    } catch (error) {
      console.error(
        `[getChatsFromServer][Store][Error occured while getChatsFromServer report list--->${error}]`
      );
      if (error.response) {
        if (error.response.status == 401){
          return context.dispatch("users/logOutFromServer", {},{root:true})
        }
        else {
          error.response.data.statusCode = error.response.status
          return error.response.data
        }
      }
      return {}
    }
  },

  async sendMessageThroughChat(context, payload = {}) {
    try {
      let resp = await axios.post(Constants.messagesUrl, payload);
      if (Constants.acceptedStatusCodes.includes(resp.status)) {
        console.log(
          `[sendMessageThroughChat][Store][Bin add resp-->${resp.status}]`
        );
        resp.data.statusCode = resp.status
        return resp.data;
      } else {
        throw `Response from server-->${resp.status}, data--->${resp.data}, statusText-->${resp.statusText}`;
      }
    } catch (error) {
      console.error(
        `[sendMessageThroughChat][Store][Error occured while sendMessageThroughChat--->${error}]`
      );
      if (error.response) {
        if (error.response.status == 401){
          return context.dispatch("users/logOutFromServer", {},{root:true})
        }
        else {
          error.response.data.statusCode = error.response.status
          return error.response.data
        }
      }
      return {}
    }
  },

  async editMessage(context, payload = {}) {
    try {
        let resp = await axios.put(`${Constants.messagesUrl}/${payload._id}`, payload);
        if (resp.status == 200) {
            resp.data.statusCode = resp.status
            return resp.data;
        } else {
            throw `Response from server-->${resp.status}, data--->${resp.data}, statusText-->${resp.statusText}`;
        }
    } catch (error) {
        console.error(
            `[editMessage][Store][Error occured while getting file info--->${error}]`
        );
        if (error.response) {
            if (error.response.status == 401) {
                return context.dispatch("users/logOutFromServer", {}, { root: true })
            } else if (error.response.status == 405) {
                return { statusCode: error.response.status, message: "failed to update file info" }
            } else {
                error.response.data.statusCode = error.response.status
                return error.response.data
            }
        }
        return {}
    }
  },

  async deleteMessage(context, payload = {}) {
    try {
        let resp = await axios.put(`${Constants.messagesUrl}/${payload._id}`, payload);
        if (Constants.acceptedStatusCodes.includes(resp.status)) {
            console.log(
                `[deleteMessage][Store][Tag Delete resp-->${resp.status}]`
            );
            resp.data.statusCode = resp.status
            return resp.data;
        } else {
            throw `Response from server-->${resp.status}, data--->${resp.data}, statusText-->${resp.statusText}`;
        }
    } catch (error) {
        console.error(
            `[deleteMessage][Store][Error occured while deleting User--->${error}]`
        );
        if (error.response) {
            if (error.response.status == 401) {
                return context.dispatch("users/logOutFromServer", {}, { root: true })
            } else {
                error.response.data.statusCode = error.response.status
                return error.response.data
            }
        }
        return {}
    }
  },


  async getChannelsFromServer(context, payload = {}) {
    try {
      let resp = await axios.get(Constants.messageChannels, payload);
      if (Constants.acceptedStatusCodes.includes(resp.status)) {
        resp.data.statusCode = resp.status
        return resp.data;
      }else {
        throw `Response from server-->${resp.status}, data--->${resp.data}, statusText-->${resp.statusText}`;
      }
    } catch (error) {
      console.error(
        `[getChannelsFromServer][Store][Error occured while getChannelsFromServer report list--->${error}]`
      );
      if (error.response) {
        if (error.response.status == 401){
          return context.dispatch("users/logOutFromServer", {},{root:true})
        }
        else {
          error.response.data.statusCode = error.response.status
          return error.response.data
        }
      }
      return {}
    }
  },


  async createMessageChannel(context, payload = {}) {
    try {
      let resp = await axios.post(Constants.messageChannels, payload);
      if (Constants.acceptedStatusCodes.includes(resp.status)) {
        console.log(
          `[createMessageChannel][Store][Bin add resp-->${resp.status}]`
        );
        resp.data.statusCode = resp.status
        return resp.data;
      } else {
        throw `Response from server-->${resp.status}, data--->${resp.data}, statusText-->${resp.statusText}`;
      }
    } catch (error) {
      console.error(
        `[createMessageChannel][Store][Error occured while createMessageChannel--->${error}]`
      );
      if (error.response) {
        if (error.response.status == 401){
          return context.dispatch("users/logOutFromServer", {},{root:true})
        }
        else {
          error.response.data.statusCode = error.response.status
          return error.response.data
        }
      }
      return {}
    }
  },

  async editChannel(context, payload = {}) {
    try {
        let resp = await axios.put(`${Constants.messageChannels}/${payload._id}`, payload);
        if (Constants.acceptedStatusCodes.includes(resp.status)) {
            console.log(
                `[editChannel][Store][Tag Delete resp-->${resp.status}]`
            );
            resp.data.statusCode = resp.status
            return resp.data;
        } else {
            throw `Response from server-->${resp.status}, data--->${resp.data}, statusText-->${resp.statusText}`;
        }
    } catch (error) {
        console.error(
            `[editChannel][Store][Error occured while deleting User--->${error}]`
        );
        if (error.response) {
            if (error.response.status == 401) {
                return context.dispatch("users/logOutFromServer", {}, { root: true })
            } else {
                error.response.data.statusCode = error.response.status
                return error.response.data
            }
        }
        return {}
    }
  },

  async deleteChannel(context, payload = {}) {
    //payload : {params:{customMetadataId: "23412123"}, data:DAM Users JSON schema}

    try {
      let resp = await axios.delete(`${Constants.messageChannels}/${payload.params._id}`, payload);
      if (Constants.acceptedStatusCodes.includes(resp.status)) {
        console.log(
          `[deleteChannel][Store][CustomMetadata Delete resp-->${resp.status}]`
        );
        resp.data.statusCode = resp.status
        return resp.data;
      } else {
        throw `Response from server-->${resp.status}, data--->${resp.data}, statusText-->${resp.statusText}`;
      }
    } catch (error) {
      console.error(
        `[deleteChannel][Store][Error occured while deleting CustomMetadata--->${error}]`
      );
      if (error.response) {
        if (error.response.status == 401){
          return context.dispatch("users/logOutFromServer", {},{root:true})
        }
        else {
          error.response.data.statusCode = error.response.status
          return error.response.data
        }
      }
      return {}
    }

  },

  async getDepartments(context, payload = {}) {
    try {
      let resp = await axios.get(Constants.departmentsURL, payload);
      if (Constants.acceptedStatusCodes.includes(resp.status)) {
        resp.data.statusCode = resp.status
        return resp.data;
      }else {
        throw `Response from server-->${resp.status}, data--->${resp.data}, statusText-->${resp.statusText}`;
      }
    } catch (error) {
      console.error(
        `[getDepartments][Store][Error occured while getDepartments report list--->${error}]`
      );
      if (error.response) {
        if (error.response.status == 401){
          return context.dispatch("users/logOutFromServer", {},{root:true})
        }
        else {
          error.response.data.statusCode = error.response.status
          return error.response.data
        }
      }
      return {}
    }
  },

  async getPermittedDepartmentsOfLoggedInUser(context, payload = {}) {
    try {
      let resp = await axios.get(Constants.permittedDepartmentsURL, payload);
      if (Constants.acceptedStatusCodes.includes(resp.status)) {
        resp.data.statusCode = resp.status
        return resp.data;
      }else {
        throw `Response from server-->${resp.status}, data--->${resp.data}, statusText-->${resp.statusText}`;
      }
    } catch (error) {
      console.error(
        `[getPermittedDepartmentsOfLoggedInUser][Store][Error occured while getPermittedDepartmentsOfLoggedInUser list--->${error}]`
      );
      if (error.response) {
        if (error.response.status == 401){
          return context.dispatch("users/logOutFromServer", {},{root:true})
        }
        else {
          error.response.data.statusCode = error.response.status
          return error.response.data
        }
      }
      return {}
    }
  },


  async createDepartment(context, payload = {}) {
    try {
      let resp = await axios.post(Constants.departmentsURL, payload);
      if (Constants.acceptedStatusCodes.includes(resp.status)) {
        console.log(
          `[createDepartment][Store][Bin add resp-->${resp.status}]`
        );
        resp.data.statusCode = resp.status
        return resp.data;
      } else {
        throw `Response from server-->${resp.status}, data--->${resp.data}, statusText-->${resp.statusText}`;
      }
    } catch (error) {
      console.error(
        `[createDepartment][Store][Error occured while createDepartment--->${error}]`
      );
      if (error.response) {
        if (error.response.status == 401){
          return context.dispatch("users/logOutFromServer", {},{root:true})
        }
        else {
          error.response.data.statusCode = error.response.status
          return error.response.data
        }
      }
      return {}
    }
  },

  async updateDepartmentInfo(context, payload = {}) {
    try {
        let resp = await axios.put(`${Constants.departmentsURL}/${payload._id}`, payload.params);
        if (Constants.acceptedStatusCodes.includes(resp.status)) {
            console.log(
                `[updateDepartmentInfo][Store][resp-->${resp.status}]`
            );
            resp.data.statusCode = resp.status
            return resp.data;
        } else {
            throw `Response from server-->${resp.status}, data--->${resp.data}, statusText-->${resp.statusText}`;
        }
    } catch (error) {
        console.error(
            `[updateDepartmentInfo][Store][Error occured while updateDepartmentInfo--->${error}]`
        );
        if (error.response) {
            if (error.response.status == 401) {
                return context.dispatch("users/logOutFromServer", {}, { root: true })
            } else {
                error.response.data.statusCode = error.response.status
                return error.response.data
            }
        }
        return {}
    }
  },

  async deleteDepartment(context, payload = {}) {
    //payload : {params:{customMetadataId: "23412123"}, data:DAM Users JSON schema}

    try {
      let resp = await axios.delete(`${Constants.departmentsURL}/${payload.params._id}`, payload);
      if (Constants.acceptedStatusCodes.includes(resp.status)) {
        console.log(
          `[deleteDepartment][Store][CustomMetadata Delete resp-->${resp.status}]`
        );
        resp.data.statusCode = resp.status
        return resp.data;
      } else {
        throw `Response from server-->${resp.status}, data--->${resp.data}, statusText-->${resp.statusText}`;
      }
    } catch (error) {
      console.error(
        `[deleteDepartment][Store][Error occured while deleting CustomMetadata--->${error}]`
      );
      if (error.response) {
        if (error.response.status == 401){
          return context.dispatch("users/logOutFromServer", {},{root:true})
        }
        else {
          error.response.data.statusCode = error.response.status
          return error.response.data
        }
      }
      return {}
    }

  },

  async getAllQuickAccessPanels(context, payload = {}) {
    try {
      let resp = await axios.get(Constants.userWorkspaceURL, payload);
      if (Constants.acceptedStatusCodes.includes(resp.status)) {
        resp.data.statusCode = resp.status
        return resp.data;
      }else {
        throw `Response from server-->${resp.status}, data--->${resp.data}, statusText-->${resp.statusText}`;
      }
    } catch (error) {
      console.error(
        `[getAllQuickAccessPanels][Store][Error occured while getAllQuickAccessPanels report list--->${error}]`
      );
      if (error.response) {
        if (error.response.status == 401){
          return context.dispatch("users/logOutFromServer", {},{root:true})
        }
        else {
          error.response.data.statusCode = error.response.status
          return error.response.data
        }
      }
      return {}
    }
  },

  async submitConfiguredQuickAccesPanels(context, payload = {}) {
    try {
      let resp = await axios.post(`${Constants.configuredUserWorkspacePanelURL}/${payload.userId}`, payload.params);
      if (Constants.acceptedStatusCodes.includes(resp.status)) {
        console.log(
          `[submitConfiguredQuickAccesPanels][Store][Bin add resp-->${resp.status}]`
        );
        resp.data.statusCode = resp.status
        return resp.data;
      } else {
        throw `Response from server-->${resp.status}, data--->${resp.data}, statusText-->${resp.statusText}`;
      }
    } catch (error) {
      console.error(
        `[submitConfiguredQuickAccesPanels][Store][Error occured while submitConfiguredQuickAccesPanels--->${error}]`
      );
      if (error.response) {
        if (error.response.status == 401){
          return context.dispatch("users/logOutFromServer", {},{root:true})
        }
        else {
          error.response.data.statusCode = error.response.status
          return error.response.data
        }
      }
      return {}
    }
  },

  async getConfiguredQuickAccessPanel(context, payload = {}) {
    try {
      let resp = await axios.get(Constants.configuredUserWorkspacePanelURL, payload);
      if (Constants.acceptedStatusCodes.includes(resp.status)) {
        resp.data.statusCode = resp.status
        return resp.data;
      }else {
        throw `Response from server-->${resp.status}, data--->${resp.data}, statusText-->${resp.statusText}`;
      }
    } catch (error) {
      console.error(
        `[getConfiguredQuickAccessPanel][Store][Error occured while getConfiguredQuickAccessPanel report list--->${error}]`
      );
      if (error.response) {
        if (error.response.status == 401){
          return context.dispatch("users/logOutFromServer", {},{root:true})
        }
        else {
          error.response.data.statusCode = error.response.status
          return error.response.data
        }
      }
      return {}
    }
  },


}










